module.exports = __webpack_public_path__ + "img/map.7b9a596c.png";